import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Form, Input, Select, Button } from 'antd';
import { SaveOutlined } from '@ant-design/icons';
import { AppStore } from 'stores';
import styled from 'styled-components';

const { Option } = Select;

const StyledForm = styled(Form)`
  .ant-input-affix-wrapper-readonly,
  .ant-input-affix-wrapper-disabled,
  input:disabled,
  input:read-only {
    background-color: #f0f0f0;
    cursor: not-allowed;
  }

  .ant-input-affix-wrapper-readonly input,
  .ant-input-affix-wrapper-disabled input {
    color: #333;
    cursor: not-allowed;
  }
`;

const ShopContactForm = ({
  form,
  onCancel = () => {},
  onSubmit = () => {},
  saving = false,
  defaultData = {},
  disableFields = [],
  hideFooter = false,
}) => {
  useEffect(() => {
    form.resetFields();
    if (AppStore.openModals.get('contact_form_modal_id')) {
      form.setFieldsValue({
        email: defaultData?.email ? defaultData?.email.split(',') : [],
        salesPerson: defaultData?.salesPerson
          ? defaultData?.salesPerson.split(',')
          : [],
        phone: defaultData?.phone ? defaultData?.phone.split(',') : [],
        prefix: '1',
      });
    }
  }, [defaultData]);

  useEffect(() => {
    if (!AppStore.openModals.get('contact_form_modal_id')) {
      form.resetFields();
    }
  }, [AppStore.openModals.get('contact_form_modal_id')]);

  const handleSubmit = (values) => {
    const newValues = {
      ...values,
      email: values.email.join(','),
      salesPerson: values.salesPerson.join(','),
      phone: values.phone.join(','),
      contactId: defaultData.id,
    };
    onSubmit(newValues);
    form.resetFields();
  };

  const handleCancel = () => {
    if (onCancel) {
      onCancel();
    }
  };

  const prefixSelector = (
    <Form.Item name="prefix" noStyle>
      <Select
        style={{ width: 70 }}
        disabled={
          disableFields.includes('phone') || disableFields.includes('*')
        }
      >
        <Option value="1">+1</Option>
      </Select>
    </Form.Item>
  );

  return (
    <StyledForm
      form={form}
      onFinish={handleSubmit}
      initialValues={{
        name: defaultData?.name || '',
        email: defaultData?.email ? defaultData?.email.split(',') : [],
        salesPerson: defaultData?.salesPerson
          ? defaultData?.salesPerson.split(',')
          : [],
        phone: defaultData?.phone ? defaultData?.phone.split(',') : [],
        prefix: '1',
      }}
      layout="vertical"
    >
      <Form.Item
        label="Name"
        name="name"
        hasFeedback
        rules={[
          {
            required: true,
            message: 'Please input the Contact Name!',
          },
        ]}
      >
        <Input
          readOnly={
            disableFields.includes('name') || disableFields.includes('*')
          }
        />
      </Form.Item>

      <Form.Item
        label="E-mail"
        name="email"
        rules={[
          {
            validator: (_, value) => {
              if (!value || value.length === 0) {
                return Promise.resolve();
              }

              const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

              const invalid = value.filter((v) => !emailRegex.test(v));
              if (invalid.length > 0) {
                return Promise.reject(
                  new Error(`Invalid email(s): ${invalid.join(', ')}`)
                );
              }

              return Promise.resolve();
            },
          },
        ]}
      >
        <Select
          mode="tags"
          style={{ width: '100%' }}
          placeholder="Enter email and press Enter, Spacebar or Comma"
          tokenSeparators={[',', ' ']}
          open={false}
          suffixIcon={null}
        />
      </Form.Item>

      <Form.Item label="Contact" name="salesPerson">
        <Select
          mode="tags"
          style={{ width: '100%' }}
          placeholder="Enter contact person and press Enter or Comma"
          tokenSeparators={[',']}
          open={false}
          suffixIcon={null}
        />
      </Form.Item>

      <Form.Item label="Phone Number" name="phone">
        <Select
          mode="tags"
          style={{ width: '100%' }}
          placeholder="Enter contact phone number and press Enter or Spacebar"
          tokenSeparators={[',']}
          open={false}
          suffixIcon={null}
        />
      </Form.Item>

      {!hideFooter && (
        <Form.Item style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Button type="default" onClick={handleCancel}>
            Cancel
          </Button>
          <Button
            loading={saving}
            style={{ marginLeft: 6 }}
            icon={<SaveOutlined />}
            type="primary"
            htmlType="submit"
          >
            Save
          </Button>
        </Form.Item>
      )}
    </StyledForm>
  );
};

ShopContactForm.propTypes = {
  form: PropTypes.object,
  onCancel: PropTypes.func,
  onSubmit: PropTypes.func,
  saving: PropTypes.bool,
  defaultData: PropTypes.object,
  disableFields: PropTypes.array,
  hideFooter: PropTypes.bool,
};

export default ShopContactForm;
